

import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Image,
  Alert,
  User,
  Avatar,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCode, faCommentDots, faEllipsis, faEye, faEyeSlash, faGem, faIdBadge, faInfo, faUnlock, faUser } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

import { linksUrl } from "../constants/enum.js"
import { setLogin } from "../state/authSlice.jsx"
import { usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { resetCompCode } from "../state/companySlice.jsx"
import { isMobile } from "react-device-detect"


export default function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)


  const [formData, setFormData] = useState({
    clientCode: "",
    loginName: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const resetValues = () => {
    setFormData({
      clientCode: "",
      loginName: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {
    
    if (data && Object.keys(data)?.length > 0) {
      navigate(linksUrl.companies)
      dispatch(
        setLogin({
          user: data.user,
          token: data.accessToken,
          menu: { appMenu: data.appMenu, userMenu: data.userMenu },
          isAuthenticated: true,
          userSetting: data.userSetting
        })
      )
      dispatch(resetCompCode())
      queryClient.removeQueries()
    }
    else {
      toast.error("Incorrect Details...", {
        "position": "top-center"
      })
    }


  }

  const { isPending, mutate: login } = usePostLogin({
    url: "/user/login",
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    let msg = ''
    if (formData.clientCode.trim() === "") {
      msg = " Client Code required , "
    }
    if (formData.loginName.trim() === "") {
      msg += " Login Name required , "
    }
    if (formData.password.trim() === "") {
      msg += " Password required , "
    }
    return msg
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    let errorMsg = validateForm()


    if (errorMsg.trim() == "") {
      login({
        data: {
          Client_Code: formData.clientCode,
          LoginName: formData.loginName,
          Password: formData.password,
        },
      })
    }
    else {
      toast.error(errorMsg, { "position": "top-center" })
    }

  }

  return (
    <div>
      <ToastContainer />
      {/* //bg-gradient-to-tr from-gray-50 to-white */}
      <div className={`${isMobile ? " bg-gradient-to-bl from-white to-lime-100 pt-20" : "bg-white"} h-screen`}>
        <div className="text-center" >

        </div>

        <div className={` ${isMobile ? " py-0 px-0" : "py-0 px-1"} "min-h-screen flex flex-col items-center justify-start  text-baseline"`}>
          {/* <div className="bg-gray-100  rounded-full w-36 text-center"> */}
          <FontAwesomeIcon className=" text-lime-600 rounded-full text-4xl p-3 bg-lime-100 " icon={faGem}></FontAwesomeIcon>
          {/* <h6 className="p-0 ,m-0" >DIAMAPP</h6> 
         </div> */}

          <div className={`${isMobile ? " border-0" : "border-1"} "  rounded-sm max-w-md w-full  py-5 px-6  
          border-lime-200 border-x-gray-200
           bg-gradient-to-b from-white to-lime-50`}>
            {/* //bg-custome-login-box-color">  border-radius */}
            <div className="mx-auto  
           border-b-0 border-gray-300 border-x-pink-200">
              <User
                description={(
                  <h1 className="text-2xl font-bold w-full border-b-2 border-gray-200  tracking-widest mx-12 dark:text-white 
          text-center  text-slate-600">
                    {/* text-custom-text-primary */}
                    LOGIN
                  </h1>
                )}
                avatarProps={{
                  src: "IITS_Logo.png",
                  size: "lg",
                  radius: "none",
                  isBordered: false,
                  // 
                }}

              />
            </div>
            <form onSubmit={handleSubmit} autoComplete='off'>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Client Code"
                  placeholder=" "
                  size="md"
                  labelPlacement="outside"
                  name="clientCode"
                  value={formData.clientCode}
                  variant="bordered"
                  startContent={<FontAwesomeIcon className="text-gray-400" icon={faIdBadge}></FontAwesomeIcon>}
                  radius="none"
                  onChange={handleChange}
                  classNames={{
                    base: "border-0 border-slate-200 ",
                    label: "uppercase text-xs font-semibold"
                  }}
                  isDisabled={isPending}
                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Login Name"
                  placeholder=" "
                  labelPlacement="outside"
                  name="loginName"
                  radius="none"
                  value={formData.loginName}
                  startContent={<FontAwesomeIcon className="text-gray-400" icon={faUser}></FontAwesomeIcon>}
                  onChange={handleChange}
                  variant="bordered"
                  classNames={{
                    base: "border-0 border-orange-200 ",
                    label: "uppercase text-xs  font-semibold"
                  }}
                  isDisabled={isPending}
                  size="md"

                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  label="Password"
                  labelPlacement="outside"
                  placeholder="Enter your password"
                  name="password"
                  size="md"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  radius="none"
                  startContent={<FontAwesomeIcon className="text-gray-400" icon={faUnlock}></FontAwesomeIcon>}
                  variant="bordered"
                  classNames={{
                    base: "border-0 border-orange-200 ",
                    label: "uppercase text-xs  font-semibold"
                  }}
                  endContent={
                    <button
                      className="focus:outline-none"
                      size="sm"
                      type="button"
                      variant="light"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}

                />
              </div>

              <div className="!mt-10 text-center">

                <Button variant="flat" radius="none"

                  className="  text-md uppercase  tracking-widest text-white  w-full  border-0 border-slate-700
                  bg-gradient-to-t from-lime-600 to-lime-700" type="submit" isLoading={isPending}>
                  Login
                </Button>
              

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  )
}
